import { useCallback, useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { NotificationPanel } from '../features/notifications/NotificationPanel';
import { api } from '../lib/api';
import { useTranslation } from '../i18n';

const POLL_INTERVAL_MS = 60_000;

// TODO(auth): replace with the authenticated user from auth context.
const CURRENT_USER = { initials: 'RK' };

export function DesktopLayout({ children }) {
  const { t } = useTranslation();
  const [panelOpen, setPanelOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const refreshUnread = useCallback(async () => {
    try {
      const data = await api.notifications.unreadCount();
      setUnreadCount(typeof data?.count === 'number' ? data.count : 0);
    } catch {
      // Network/worker offline — keep last known count.
    }
  }, []);

  useEffect(() => {
    refreshUnread();
    const id = window.setInterval(refreshUnread, POLL_INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [refreshUnread]);

  function openPanel() {
    setPanelOpen(true);
    refreshUnread();
  }

  return (
    <div className="app-shell">
      <Sidebar />

      <header className="app-header">
        <div className="app-header__brand">
          <img className="app-header__logo" src="/f8m-logo.svg" alt="" />
          <div className="app-header__title">{t('app.title')}</div>
        </div>

        <div className="app-header__actions">
          <button
            type="button"
            className="app-header__bell"
            aria-label={t('header.notifications')}
            aria-haspopup="dialog"
            aria-expanded={panelOpen}
            onClick={openPanel}
          >
            <span aria-hidden="true">🔔</span>
            {unreadCount > 0 && (
              <span className="app-header__badge">{unreadCount}</span>
            )}
          </button>

          <span
            className="app-header__health"
            role="status"
            aria-label={t('header.systemHealthy')}
            title={t('header.systemHealthy')}
          />

          <div className="app-header__avatar" aria-label="Account">
            {CURRENT_USER.initials}
          </div>
        </div>
      </header>

      <main className="app-main">
        <div className="app-main__inner">{children}</div>
      </main>

      <NotificationPanel
        open={panelOpen}
        onClose={() => setPanelOpen(false)}
        onChange={refreshUnread}
      />
    </div>
  );
}
